import type { DynamicQuestionsConfig } from '../../config/types';
import { matchesUrlPattern } from '../web/urlUtils';

export function resolveDynamicQuestionsForUrl(
    questionsConfig: string[] | DynamicQuestionsConfig,
    currentUrl: string
): string[] {
    if (Array.isArray(questionsConfig)) {
        return questionsConfig;
    }

    for (const pageRule of questionsConfig.pages ?? []) {
        for (const pattern of pageRule.patterns ?? []) {
            if (matchesUrlPattern(currentUrl, pattern)) {
                return pageRule.questions ?? [];
            }
        }
    }

    return questionsConfig.default ?? [];
}
